// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Data Grid Component Styles */

/* Group Header Row */
.group-header-row {
    display: flex;
    background-color: #0066B2;
    min-width: 100%;
    position: sticky;
    top: 0;
    height: 32px;
}

.group-header-cell {
    padding: 0 12px;
    font-size: 13px;
    font-weight: 600;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
}

.group-header-cell--labeled {
    color: #ffffff;
}

/* Sticky column support */
.group-header-cell.sticky-left-1 {
    position: static;
    left: auto;
}

.group-header-cell.sticky-left-2 {
    position: static;
    left: auto;
}

.group-header-cell.sticky-right {
    position: static;
    right: auto;
}

/* Column borders for first/last columns in a group - headers only */
.group-col-start.mat-mdc-header-cell {
    border-left: 1px solid #dee2e6 !important;
}

.group-col-end.mat-mdc-header-cell {
    border-right: 1px solid #dee2e6 !important;
}

/* Sticky columns */
.sticky-left-1 {
    position: static !important;
    left: auto !important;
    z-index: auto !important;
}

.sticky-left-2 {
    position: static !important;
    left: auto !important;
    z-index: auto !important;
}

.sticky-right {
    position: static !important;
    right: auto !important;
    z-index: auto !important;
}

/* Header cells get their own background */
.sticky-left-1.mat-mdc-header-cell,
.sticky-left-2.mat-mdc-header-cell,
.sticky-right.mat-mdc-header-cell {
    background-color: #0066B2 !important;
    z-index: auto !important;
}

/* Filter row cells */
.filter-row .sticky-left-1.mat-mdc-cell,
.filter-row .sticky-left-2.mat-mdc-cell,
.filter-row .sticky-right.mat-mdc-cell {
    background-color: #f8f9fa !important;
}

/* Data row sticky cells inherit from row by default */
.data-row .sticky-left-1.mat-mdc-cell,
.data-row .sticky-left-2.mat-mdc-cell,
.data-row .sticky-right.mat-mdc-cell {
    background-color: inherit;
}

.data-grid-container {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
}

/* Table Container */
.table-container {
    flex: 1;
    min-height: 0;
    overflow-x: auto;
    overflow-y: auto;
}

/* table-scroll-wrapper is the containing block for the overlay (scrolls with table) */
.table-scroll-wrapper {
    position: relative;
    width: -moz-fit-content;
    width: fit-content;
    min-width: 100%;
}

/* Loading overlay — top is set dynamically via [style.top] binding */
.table-loading-overlay {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    overflow: hidden;
    z-index: 10;
}

/* Skeleton rows */
.skl-loading-row {
    display: flex;
    align-items: center;
    height: 48px;
    min-height: 48px;
    flex-shrink: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.skl-loading-row:last-child {
    border-bottom: none;
}

/* Each skeleton cell mirrors a real mat-mdc-cell */
.skl-loading-cell {
    display: flex;
    align-items: center;
    padding: 0 16px;
    height: 100%;
    overflow: hidden;
    flex-shrink: 0;
    min-width: 0;
    white-space: nowrap;
}

.skl-loading-cell--actions {
    justify-content: flex-start;
}

/* Sticky skeleton cells — same offsets as real sticky columns */
.skl-loading-cell.sticky-left-1 {
    position: static;
    left: auto;
}

.skl-loading-cell.sticky-left-2 {
    position: static;
    left: auto;
}

.skl-loading-cell.sticky-right {
    position: static;
    right: auto;
}

.skl-loading-bar {
    height: 13px;
    border-radius: 3px;
    flex-shrink: 0;
    background: linear-gradient(90deg, #e9ecef 25%, #f4f5f7 50%, #e9ecef 75%);
    background-size: 200% 100%;
    animation: skl-shimmer 1.5s ease-in-out infinite;
}

.skl-loading-button-group {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: nowrap;
}

@keyframes skl-shimmer {
    0% {
        background-position: -200% 0;
    }

    100% {
        background-position: 200% 0;
    }
}

/* No Data Row */
.no-data-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 48px 24px;
    color: #6c757d;
    font-size: 0.95rem;
}

.no-data-message mat-icon {
    font-size: 40px;
    width: 40px;
    height: 40px;
    color: #adb5bd;
}

/* .table-scroll-wrapper positioning moved above (near overlay styles) */

.data-grid-table .mat-mdc-table {
    display: table;
}

/* Header Styling */
.data-grid-table .mat-mdc-header-row {
    height: 56px;
    background-color: #0066B2;
}

.data-grid-table .mat-mdc-header-row .mat-mdc-header-cell {
    color: #ffffff;
    background-color: #0066B2;
    white-space: nowrap;
    overflow: hidden;
}

::ng-deep .data-grid-table .mat-sort-header-arrow {
    color: #ffffff !important;
}

.sticky-header {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #0066B2;
}

/* Filter Row Styling */
.filter-row {
    background-color: #f8f9fa;
    height: 48px;
    min-height: 48px;
}

.filter-row .mat-mdc-cell {
    padding: 8px 12px;
    border-bottom: 1px solid #dee2e6;
}

.filter-input {
    width: 100%;
    font-size: 12px;
    border-radius: 4px;
    border: 1px solid #ced4da;
    padding: 4px 8px;
    background-color: white;
}

.filter-input:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.filter-input::placeholder {
    color: #6c757d;
    font-style: italic;
}

/* Data Row Styling */
.data-row {
    height: 48px;
    min-height: 48px;
}

.data-row .mat-mdc-cell {
    background-color: inherit;
}

/* Action Cell Styling */
.action-cell {
    text-align: left;
    padding: 8px 16px !important;
    min-width: 230px;
}

.action-cell.sticky-right {
    display: flex;
    align-items: center;
    gap: 8px;
}

.action-button {
    margin: 0 2px;
    min-width: auto;
    padding: 4px 8px;
    font-size: 12px;
}

/* Rejected row: single continuous strikethrough line across the full row */
/* Using cell-level ::after instead of row-level to avoid height inflation
   on display:table-row elements caused by position:relative */
.data-row.rejected-row .mat-mdc-cell {
    /* text-decoration: line-through; */
    color: #999;
    position: relative;
}

.data-row.rejected-row .mat-mdc-cell::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: #999;
    pointer-events: none;
    z-index: 5;
}


/* Table Cell Styling */
.mat-mdc-cell,
.mat-mdc-header-cell {
    padding: 12px 16px !important;
    text-align: left;
}

.mat-mdc-cell {
    font-size: 14px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.mat-mdc-header-cell {
    font-weight: 600;
    color: #333;
}

/* Total Count */
.total-count {
    margin-top: 16px;
    font-size: 14px;
    color: #666;
    text-align: right;
    padding: 0 8px;
}

/* Paginator Styling */
mat-paginator {
    display: none;
}

/* Custom Paginator */
.custom-paginator {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 24px;
    margin-top: 16px;
    flex-wrap: wrap;
}

.items-per-page {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #555;

    label {
        margin: 0;
        line-height: 1;
    }
}

.items-per-page select {
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 2px 6px;
    font-size: 14px;
    cursor: pointer;
}

.pagination {
    display: flex;
    align-items: center;
    gap: 4px;
}

/* Responsive Design */
@media (max-width: 768px) {
    .data-grid-table {
        font-size: 12px;
    }

    .mat-mdc-cell,
    .mat-mdc-header-cell {
        padding: 8px 4px !important;
    }

    .action-button {
        padding: 2px 4px;
        font-size: 10px;
    }
}

/* Custom scrollbar for table container */
.table-container::-webkit-scrollbar {
    height: 8px;
}

.table-container::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
    background: #555;
}

/* Multi-select dropdown filter */
.filter-select-dropdown {
    width: 100%;
    font-size: 12px;
}

::ng-deep .filter-select-dropdown .mat-mdc-select-trigger {
    font-size: 12px;
    height: 28px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 0 8px;
    background-color: white;
}

::ng-deep .filter-select-dropdown .mat-mdc-select-value {
    font-size: 12px;
    color: #495057;
}

::ng-deep .filter-select-dropdown .mat-mdc-select-placeholder {
    color: #6c757d;
    font-style: italic;
}

::ng-deep .filter-dropdown-panel .mat-mdc-option {
    font-size: 13px;
    min-height: 36px;
}

::ng-deep .filter-dropdown-panel .mat-mdc-option .mdc-checkbox {
    margin-right: 4px;
}

::ng-deep .filter-dropdown-panel .mat-pseudo-checkbox {
    border-color: #0066B2 !important;
}

::ng-deep .filter-dropdown-panel .mat-pseudo-checkbox-checked,
::ng-deep .filter-dropdown-panel .mat-pseudo-checkbox-indeterminate {
    background-color: #0066B2 !important;
    border-color: #0066B2 !important;
}

/* Ensure the panel is at least wide enough to show full option text */
::ng-deep .cdk-overlay-pane:has(.filter-dropdown-panel) {
    min-width: 220px !important;
    width: auto !important;
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/shared/data-grid/data-grid.component.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B,qBAAqB;AACrB;IACI,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA,0BAA0B;AAC1B;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA,oEAAoE;AACpE;IACI,yCAAyC;AAC7C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA,mBAAmB;AACnB;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA,0CAA0C;AAC1C;;;IAGI,oCAAoC;IACpC,wBAAwB;AAC5B;;AAEA,qBAAqB;AACrB;;;IAGI,oCAAoC;AACxC;;AAEA,sDAAsD;AACtD;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;AACjB;;AAEA,oBAAoB;AACpB;IACI,OAAO;IACP,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,sFAAsF;AACtF;IACI,kBAAkB;IAClB,uBAAkB;IAAlB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,qEAAqE;AACrE;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;AACf;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;AACvB;;AAEA,mDAAmD;AACnD;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,gEAAgE;AAChE;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,yEAAyE;IACzE,0BAA0B;IAC1B,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA,wEAAwE;;AAExE;IACI,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,yBAAyB;AAC7B;;AAEA,uBAAuB;AACvB;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,gDAAgD;AACpD;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA,qBAAqB;AACrB;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,wBAAwB;AACxB;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA,2EAA2E;AAC3E;8DAC8D;AAC9D;IACI,mCAAmC;IACnC,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,oBAAoB;IACpB,UAAU;AACd;;;AAGA,uBAAuB;AACvB;;IAEI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI,aAAa;AACjB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,WAAW;;IAEX;QACI,SAAS;QACT,cAAc;IAClB;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,sBAAsB;AACtB;IACI;QACI,eAAe;IACnB;;IAEA;;QAEI,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;AACJ;;AAEA,yCAAyC;AACzC;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,iCAAiC;AACjC;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA,sEAAsE;AACtE;IACI,2BAA2B;IAC3B,sBAAsB;AAC1B","sourcesContent":["/* Data Grid Component Styles */\n\n/* Group Header Row */\n.group-header-row {\n    display: flex;\n    background-color: #0066B2;\n    min-width: 100%;\n    position: sticky;\n    top: 0;\n    height: 32px;\n}\n\n.group-header-cell {\n    padding: 0 12px;\n    font-size: 13px;\n    font-weight: 600;\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 32px;\n}\n\n.group-header-cell--labeled {\n    color: #ffffff;\n}\n\n/* Sticky column support */\n.group-header-cell.sticky-left-1 {\n    position: static;\n    left: auto;\n}\n\n.group-header-cell.sticky-left-2 {\n    position: static;\n    left: auto;\n}\n\n.group-header-cell.sticky-right {\n    position: static;\n    right: auto;\n}\n\n/* Column borders for first/last columns in a group - headers only */\n.group-col-start.mat-mdc-header-cell {\n    border-left: 1px solid #dee2e6 !important;\n}\n\n.group-col-end.mat-mdc-header-cell {\n    border-right: 1px solid #dee2e6 !important;\n}\n\n/* Sticky columns */\n.sticky-left-1 {\n    position: static !important;\n    left: auto !important;\n    z-index: auto !important;\n}\n\n.sticky-left-2 {\n    position: static !important;\n    left: auto !important;\n    z-index: auto !important;\n}\n\n.sticky-right {\n    position: static !important;\n    right: auto !important;\n    z-index: auto !important;\n}\n\n/* Header cells get their own background */\n.sticky-left-1.mat-mdc-header-cell,\n.sticky-left-2.mat-mdc-header-cell,\n.sticky-right.mat-mdc-header-cell {\n    background-color: #0066B2 !important;\n    z-index: auto !important;\n}\n\n/* Filter row cells */\n.filter-row .sticky-left-1.mat-mdc-cell,\n.filter-row .sticky-left-2.mat-mdc-cell,\n.filter-row .sticky-right.mat-mdc-cell {\n    background-color: #f8f9fa !important;\n}\n\n/* Data row sticky cells inherit from row by default */\n.data-row .sticky-left-1.mat-mdc-cell,\n.data-row .sticky-left-2.mat-mdc-cell,\n.data-row .sticky-right.mat-mdc-cell {\n    background-color: inherit;\n}\n\n.data-grid-container {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    min-height: 0;\n}\n\n/* Table Container */\n.table-container {\n    flex: 1;\n    min-height: 0;\n    overflow-x: auto;\n    overflow-y: auto;\n}\n\n/* table-scroll-wrapper is the containing block for the overlay (scrolls with table) */\n.table-scroll-wrapper {\n    position: relative;\n    width: fit-content;\n    min-width: 100%;\n}\n\n/* Loading overlay — top is set dynamically via [style.top] binding */\n.table-loading-overlay {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: #fff;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    overflow: hidden;\n    z-index: 10;\n}\n\n/* Skeleton rows */\n.skl-loading-row {\n    display: flex;\n    align-items: center;\n    height: 48px;\n    min-height: 48px;\n    flex-shrink: 0;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n}\n\n.skl-loading-row:last-child {\n    border-bottom: none;\n}\n\n/* Each skeleton cell mirrors a real mat-mdc-cell */\n.skl-loading-cell {\n    display: flex;\n    align-items: center;\n    padding: 0 16px;\n    height: 100%;\n    overflow: hidden;\n    flex-shrink: 0;\n    min-width: 0;\n    white-space: nowrap;\n}\n\n.skl-loading-cell--actions {\n    justify-content: flex-start;\n}\n\n/* Sticky skeleton cells — same offsets as real sticky columns */\n.skl-loading-cell.sticky-left-1 {\n    position: static;\n    left: auto;\n}\n\n.skl-loading-cell.sticky-left-2 {\n    position: static;\n    left: auto;\n}\n\n.skl-loading-cell.sticky-right {\n    position: static;\n    right: auto;\n}\n\n.skl-loading-bar {\n    height: 13px;\n    border-radius: 3px;\n    flex-shrink: 0;\n    background: linear-gradient(90deg, #e9ecef 25%, #f4f5f7 50%, #e9ecef 75%);\n    background-size: 200% 100%;\n    animation: skl-shimmer 1.5s ease-in-out infinite;\n}\n\n.skl-loading-button-group {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: nowrap;\n}\n\n@keyframes skl-shimmer {\n    0% {\n        background-position: -200% 0;\n    }\n\n    100% {\n        background-position: 200% 0;\n    }\n}\n\n/* No Data Row */\n.no-data-message {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    padding: 48px 24px;\n    color: #6c757d;\n    font-size: 0.95rem;\n}\n\n.no-data-message mat-icon {\n    font-size: 40px;\n    width: 40px;\n    height: 40px;\n    color: #adb5bd;\n}\n\n/* .table-scroll-wrapper positioning moved above (near overlay styles) */\n\n.data-grid-table .mat-mdc-table {\n    display: table;\n}\n\n/* Header Styling */\n.data-grid-table .mat-mdc-header-row {\n    height: 56px;\n    background-color: #0066B2;\n}\n\n.data-grid-table .mat-mdc-header-row .mat-mdc-header-cell {\n    color: #ffffff;\n    background-color: #0066B2;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n::ng-deep .data-grid-table .mat-sort-header-arrow {\n    color: #ffffff !important;\n}\n\n.sticky-header {\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    background-color: #0066B2;\n}\n\n/* Filter Row Styling */\n.filter-row {\n    background-color: #f8f9fa;\n    height: 48px;\n    min-height: 48px;\n}\n\n.filter-row .mat-mdc-cell {\n    padding: 8px 12px;\n    border-bottom: 1px solid #dee2e6;\n}\n\n.filter-input {\n    width: 100%;\n    font-size: 12px;\n    border-radius: 4px;\n    border: 1px solid #ced4da;\n    padding: 4px 8px;\n    background-color: white;\n}\n\n.filter-input:focus {\n    border-color: #80bdff;\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.filter-input::placeholder {\n    color: #6c757d;\n    font-style: italic;\n}\n\n/* Data Row Styling */\n.data-row {\n    height: 48px;\n    min-height: 48px;\n}\n\n.data-row .mat-mdc-cell {\n    background-color: inherit;\n}\n\n/* Action Cell Styling */\n.action-cell {\n    text-align: left;\n    padding: 8px 16px !important;\n    min-width: 230px;\n}\n\n.action-cell.sticky-right {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.action-button {\n    margin: 0 2px;\n    min-width: auto;\n    padding: 4px 8px;\n    font-size: 12px;\n}\n\n/* Rejected row: single continuous strikethrough line across the full row */\n/* Using cell-level ::after instead of row-level to avoid height inflation\n   on display:table-row elements caused by position:relative */\n.data-row.rejected-row .mat-mdc-cell {\n    /* text-decoration: line-through; */\n    color: #999;\n    position: relative;\n}\n\n.data-row.rejected-row .mat-mdc-cell::after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 0;\n    width: 100%;\n    height: 1px;\n    background-color: #999;\n    pointer-events: none;\n    z-index: 5;\n}\n\n\n/* Table Cell Styling */\n.mat-mdc-cell,\n.mat-mdc-header-cell {\n    padding: 12px 16px !important;\n    text-align: left;\n}\n\n.mat-mdc-cell {\n    font-size: 14px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n}\n\n.mat-mdc-header-cell {\n    font-weight: 600;\n    color: #333;\n}\n\n/* Total Count */\n.total-count {\n    margin-top: 16px;\n    font-size: 14px;\n    color: #666;\n    text-align: right;\n    padding: 0 8px;\n}\n\n/* Paginator Styling */\nmat-paginator {\n    display: none;\n}\n\n/* Custom Paginator */\n.custom-paginator {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 24px;\n    margin-top: 16px;\n    flex-wrap: wrap;\n}\n\n.items-per-page {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    color: #555;\n\n    label {\n        margin: 0;\n        line-height: 1;\n    }\n}\n\n.items-per-page select {\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 2px 6px;\n    font-size: 14px;\n    cursor: pointer;\n}\n\n.pagination {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .data-grid-table {\n        font-size: 12px;\n    }\n\n    .mat-mdc-cell,\n    .mat-mdc-header-cell {\n        padding: 8px 4px !important;\n    }\n\n    .action-button {\n        padding: 2px 4px;\n        font-size: 10px;\n    }\n}\n\n/* Custom scrollbar for table container */\n.table-container::-webkit-scrollbar {\n    height: 8px;\n}\n\n.table-container::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 4px;\n}\n\n.table-container::-webkit-scrollbar-thumb:hover {\n    background: #555;\n}\n\n/* Multi-select dropdown filter */\n.filter-select-dropdown {\n    width: 100%;\n    font-size: 12px;\n}\n\n::ng-deep .filter-select-dropdown .mat-mdc-select-trigger {\n    font-size: 12px;\n    height: 28px;\n    border: 1px solid #ced4da;\n    border-radius: 4px;\n    padding: 0 8px;\n    background-color: white;\n}\n\n::ng-deep .filter-select-dropdown .mat-mdc-select-value {\n    font-size: 12px;\n    color: #495057;\n}\n\n::ng-deep .filter-select-dropdown .mat-mdc-select-placeholder {\n    color: #6c757d;\n    font-style: italic;\n}\n\n::ng-deep .filter-dropdown-panel .mat-mdc-option {\n    font-size: 13px;\n    min-height: 36px;\n}\n\n::ng-deep .filter-dropdown-panel .mat-mdc-option .mdc-checkbox {\n    margin-right: 4px;\n}\n\n::ng-deep .filter-dropdown-panel .mat-pseudo-checkbox {\n    border-color: #0066B2 !important;\n}\n\n::ng-deep .filter-dropdown-panel .mat-pseudo-checkbox-checked,\n::ng-deep .filter-dropdown-panel .mat-pseudo-checkbox-indeterminate {\n    background-color: #0066B2 !important;\n    border-color: #0066B2 !important;\n}\n\n/* Ensure the panel is at least wide enough to show full option text */\n::ng-deep .cdk-overlay-pane:has(.filter-dropdown-panel) {\n    min-width: 220px !important;\n    width: auto !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
